import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import config from '@/services/config'

import SearchComponent from '@/components/SearchComponent.vue'
import DashboardSales from '@/components/DashboardSales.vue'
import DashboardSalesChart from '@/components/DashboardSalesChart.vue'
import DashboardSalesChartOld from '@/components/DashboardSalesChartOld.vue'
import DashboardMargin from '@/components/DashboardMargin.vue'
import DashboardMarginChart from '@/components/DashboardMarginChart.vue'
import DashboardRules from '@/components/DashboardRules.vue'
import DashboardRulesDetail from '@/components/DashboardRulesDetail.vue'
import DashboardPoSo from '@/components/DashboardPoSo.vue'
import DashboardParts from '@/components/DashboardParts.vue'
import DashboardSpecialPricing from '@/components/DashboardSpecialPricing.vue'
import DashboardPricingFollowup from '@/components/DashboardPricingFollowup.vue'
import DashboardErrors from '@/components/DashboardErrors.vue'
import DashboardQuotes from '@/components/DashboardQuotes.vue'
import DashboardQuotesChart from '@/components/DashboardQuotesChart.vue'
import DashboardPurchase from '@/components/DashboardPurchase.vue'
import DashboardPricingAnalysis from '@/components/DashboardPricingAnalysis.vue'
import DashboardPartsSpreadsheetUpload from '@/components/DashboardPartsSpreadsheetUpload.vue'
import DashboardShippingSpreadsheetUpload from '@/components/DashboardShippingSpreadsheetUpload.vue'
import DashboardShipping from '@/components/DashboardShipping.vue'
import DashboardPartHistory from '@/components/DashboardPartHistory.vue'
import DashboardMatchSaleQuote from '@/components/DashboardMatchSaleQuote.vue'
import TestPartsDB from '@/components/TestPartsDB.vue'
import LoginPage from '@/components/pages/LoginPage.vue'
import ForgotPassword from '@/components/pages/ForgotPassword.vue'
import SignupPage from '../components/pages/SignupPage.vue'
import Setup2FAKey from '../components/pages/Setup2FAKey.vue'
import ChangePassword from '../components/pages/ChangePassword.vue'
import DashboardBase from '@/components/pages/DashboardBase.vue'
import FlowConfigurationLiveSearchPage from '@/components/pages/FlowConfigurationLiveSearchPage.vue'
import MyListQuotes from '@/components/pages/MyListQuotes.vue'
import ProfileConfig from '@/components/pages/ProfileConfig.vue'
import SubstitutesTreePage from '@/components/pages/SubstitutesTreePage.vue'
import SubstitutesBadRequestsPage from '@/components/pages/SubstitutesBadRequestsPage.vue'
import NotFound from '@/components/pages/NotFound.vue'
import AppShell from '@/components/layouts/AppShell.vue'

// Setup app routes
const crmRoutes = [
    { path: '/', redirect: { name: 'login' } },
    {
        path: '/',
        component: AppShell,
        children: [
            { path: 'dashboard', name: 'dashboard', component: DashboardBase, props: true },
            { path: 'my-quotes', name: 'my-quotes', component: MyListQuotes, props: true },
            {
                path: 'profile-config',
                name: 'profile-config',
                component: ProfileConfig,
                props: true,
            },
            {
                path: 'substitutes/tree',
                name: 'substitutes-tree',
                component: SubstitutesTreePage,
                props: true,
            },
            {
                path: 'substitutes/bad-requests',
                name: 'substitutes-bad-requests',
                component: SubstitutesBadRequestsPage,
                props: true,
            },
            {
                path: 'admin/flow-configurations/live-search',
                name: 'flow-config-live-search',
                component: FlowConfigurationLiveSearchPage,
                props: true,
                meta: { staffOnly: true },
            },
            { path: 'Dashboard/Margin', name: 'dash_margin', component: DashboardMargin },
            {
                path: 'Dashboard/Margin/Chart',
                name: 'dash_margin_chart',
                component: DashboardMarginChart,
            },
            {
                path: 'Dashboard/Match/Sale-Quote',
                name: 'dash_match_sale_quote',
                component: DashboardMatchSaleQuote,
            },
            {
                path: 'Dashboard/Sales/Chart',
                name: 'dash_sales_chart',
                component: DashboardSalesChart,
            },
            { path: 'Dashboard/Parts', name: 'dash_parts', component: DashboardParts },
            {
                path: 'Dashboard/Pricing/Followup',
                name: 'dash_pricing_followup',
                component: DashboardPricingFollowup,
            },
            { path: 'Dashboard/Quotes', name: 'dash_quotes', component: DashboardQuotes },
            {
                path: 'Dashboard/Pricing/Analysis',
                name: 'dashPricingAnalysis',
                component: DashboardPricingAnalysis,
            },
            {
                path: 'Dashboard/Parts/History',
                name: 'dash_part_history',
                component: DashboardPartHistory,
            },
        ],
    },

    // Authentication
    { path: '/login', name: 'login', component: LoginPage, props: true, meta: { public: true } },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        props: true,
        meta: { public: true },
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: SignupPage,
        props: true,
        meta: { public: true },
    },
    {
        path: '/setup-2fa-key',
        name: 'setup-2fa-key',
        component: Setup2FAKey,
        props: true,
        meta: { public: true },
    },
    {
        path: '/change-password/:uid/:token/',
        name: 'change-password',
        component: ChangePassword,
        props: true,
        meta: { public: true },
    },

    { path: '/Search/:route_sa_id', name: 'search', component: SearchComponent, props: true },
    {
        path: '/Research',
        name: 'research',
        component: SearchComponent,
        props: (route) => ({ route_generic_research_part_list: route.query.parts }),
    },
    { path: '/Dashboard/Sales', name: 'dash_sales', component: DashboardSales },
    { path: '/Dashboard/Rules', name: 'dash_rules', component: DashboardRules },
    { path: '/Dashboard/Rules/Detail', name: 'dash_rules_detail', component: DashboardRulesDetail },
    { path: '/Dashboard/PoSo', name: 'dash_po_so', component: DashboardPoSo },
    {
        path: '/Dashboard/Sales/Chart_Old',
        name: 'dash_sales_chart_old',
        component: DashboardSalesChartOld,
    },
    {
        path: '/Dashboard/Pricing',
        name: 'dash_special_pricing',
        component: DashboardSpecialPricing,
    },
    { path: '/Dashboard/Errors', name: 'dash_errors', component: DashboardErrors },
    { path: '/Dashboard/Quotes/Chart', name: 'dash_quotes_chart', component: DashboardQuotesChart },
    { path: '/Dashboard/Purchase', name: 'dash_purchase', component: DashboardPurchase },
    {
        path: '/Dashboard/Parts/SpreadsheetUpload',
        name: 'dash_parts_spreadsheet_upload',
        component: DashboardPartsSpreadsheetUpload,
    },
    {
        path: '/Dashboard/Shipping/SpreadsheetUpload',
        name: 'dash_shipping_spreadsheet_upload',
        component: DashboardShippingSpreadsheetUpload,
    },
    { path: '/Dashboard/Shipping', name: 'dash_shipping', component: DashboardShipping },
    { path: '/Test/PartsDB', name: 'dash_parts_db', component: TestPartsDB },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound, meta: { public: true } },
]

const invoiceDashboardRoutes = [
    {
        path: '/',
        component: () =>
            import('@/components/invoice-dashboard/layouts/InvoiceDashboardShell.vue'),
        meta: { requiresStaff: true },
        children: [
            { path: '', redirect: { name: 'invoice-overview' } },
            {
                path: 'overview',
                name: 'invoice-overview',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceOverviewPage.vue'),
            },
            {
                path: 'documents',
                name: 'invoice-documents',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceDocumentsPage.vue'),
            },
            {
                path: 'flight-hours',
                name: 'invoice-flight-hours',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceFlightHoursPage.vue'),
            },
            {
                path: 'search',
                name: 'invoice-search',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceSearchPage.vue'),
            },
            {
                path: 'fleet',
                name: 'invoice-fleet',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceFleetPage.vue'),
            },
            {
                path: 'documents/:documentId',
                name: 'invoice-document-detail',
                component: () =>
                    import(
                        '@/components/invoice-dashboard/views/InvoiceDocumentDetailPage.vue'
                    ),
                props: true,
            },
            {
                path: 'admin/ai/usage',
                name: 'invoice-ai-usage',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceAIUsagePage.vue'),
                meta: { superuserOnly: true },
            },
            {
                path: 'admin/ai/limits',
                name: 'invoice-ai-limits',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceAILimitsPage.vue'),
                meta: { superuserOnly: true },
            },
            {
                path: 'admin/ai/pricing',
                name: 'invoice-ai-pricing',
                component: () =>
                    import('@/components/invoice-dashboard/views/InvoiceAIPricingPage.vue'),
                meta: { superuserOnly: true },
            },
        ],
    },
    { path: '/login', name: 'login', component: LoginPage, props: true, meta: { public: true } },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        props: true,
        meta: { public: true },
    },
    {
        path: '/setup-2fa-key',
        name: 'setup-2fa-key',
        component: Setup2FAKey,
        props: true,
        meta: { public: true },
    },
    {
        path: '/change-password/:uid/:token/',
        name: 'change-password',
        component: ChangePassword,
        props: true,
        meta: { public: true },
    },
    {
        path: '/access-denied',
        name: 'invoice-access-denied',
        component: () =>
            import(
                '@/components/invoice-dashboard/views/InvoiceDashboardForbiddenPage.vue'
            ),
        meta: { public: true },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'invoice-not-found',
        component: () =>
            import('@/components/invoice-dashboard/views/InvoiceDashboardNotFoundPage.vue'),
        meta: { requiresStaff: true },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: config.isInvoiceDashboard() ? invoiceDashboardRoutes : crmRoutes,
})

router.beforeEach(async (to) => {
    const isPublic = to.matched.some((record) => record.meta.public)
    const userStore = useUserStore()
    const isInvoiceDashboard = config.isInvoiceDashboard()
    const authenticatedHome = isInvoiceDashboard ? 'invoice-overview' : 'dashboard'

    if (isPublic) {
        if (to.name === 'login') {
            const token = config.getCookie('token')
            if (token) {
                const ok = await userStore.initializeSession()
                if (ok) {
                    if (
                        isInvoiceDashboard &&
                        (!userStore.isStaff || !userStore.isActive)
                    ) {
                        return { name: 'invoice-access-denied' }
                    }
                    return { name: authenticatedHome }
                }
            }
        }
        return true
    }

    const token = config.getCookie('token')
    if (!token) {
        userStore.setRedirectAfterLoginPath(to.fullPath)
        return { name: 'login' }
    }

    const ok = await userStore.initializeSession()
    if (!ok) {
        userStore.setRedirectAfterLoginPath(to.fullPath)
        return { name: 'login' }
    }

    if (
        isInvoiceDashboard &&
        to.name !== 'invoice-access-denied' &&
        (!userStore.isStaff || !userStore.isActive)
    ) {
        return { name: 'invoice-access-denied' }
    }

    const superuserOnly = to.matched.some((record) => record.meta.superuserOnly)
    if (superuserOnly && !userStore.isSuperuser) {
        return { name: isInvoiceDashboard ? 'invoice-overview' : 'dashboard' }
    }

    const searchDemoRoutes = new Set(['dashboard', 'my-quotes'])
    if (config.isSearchDemo?.() && !searchDemoRoutes.has(to.name)) {
        return { name: 'dashboard' }
    }

    const staffOnly = to.matched.some((record) => record.meta.staffOnly)
    if (staffOnly && !userStore.isStaff) {
        return { name: 'dashboard' }
    }

    return true
})

export default router
